import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export class CanDeleteEndPointModel extends BaseModel implements IRestModel {

    public canDelete: boolean = null;
    public errors: Array<string> = null;
    public readonly isIRestModel = true;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'EM-CanDeleteEndPointModel');

        this.errors = restModel.Errors;
    }

    public toRestApiModel() {
        throw new Error('Method not implemented.');
    }
}
